import { Component, OnInit } from '@angular/core';
import { ShapeComponent } from '../../components/shape/shape.component';
import { MousePosition, MNC } from '../../model/shape';
import { ShapeType } from '../../model/shape-types';

@Component({
  selector: 'app-mnc',
  templateUrl: './mnc.component.html',
  styleUrls: ['./mnc.component.scss']
})
export class MncComponent extends ShapeComponent implements OnInit {

  constructor() {
    super();
    //   console.log('TextComponent constructor');
    this.shape = new MNC();
    this.shapeType = ShapeType.MNC;
  }

  ngOnInit() {
    //   console.log('TextComponent ngOnInit');
  }

  updateShapeProperties(value: any) {
    if (this.shape instanceof MNC) {
      this.shape.shapeProperties.name = value.name;
      this.shape.value = value.value;
      this.shape.originX = value.x;
      this.shape.originY = value.y;
    }
  }

  setStyles() {
    const styles = {
      fill: this.shape.shapeProperties.strokeColor
    };
    return styles;
  }

  startDrawing(beginPosition: MousePosition): void {
    if (this.shape instanceof MNC) {
      this.shape.originX = beginPosition.x;
      this.shape.originY = beginPosition.y;
      this.shape['font-family'] = 'Arial';
      this.shape['font-size'] = 16;
    }
    //   console.log('MNC startDrawing at ', beginPosition, ', ', this.shape);
  }
}
